import angular from "angular";

angular
	.module('app')
	.component('dfApplicationAddDetail', {
		template: require('./df-application-add-detail.html'),
        controller: ['$http', controller],
        bindings: {
			resolve: '<',
			close: '&',
			dismiss: '&'
        }
    });
    
function controller($http) {
 
	let $ctrl = this;

	$ctrl.page = 1;
	$ctrl.perPage = '10';

	$ctrl.category = null;
	$ctrl.search = null;

	$ctrl.appDetails = [];
	$ctrl.oldAppDetails = [];
	$ctrl.totalSelect = 0;

	$ctrl.$onInit = function ($http) {

		$ctrl.categories = $ctrl.resolve.categories;
		$ctrl.resolve.appCategories.forEach(function (category) {
			if (category.app_details.length) {
				category.app_details.forEach(function (detail) {
					$ctrl.appDetails.push(detail);
				})
			}
			if (category.old_app_details && category.old_app_details.length) {
				category.old_app_details.forEach(function (detail) {
					$ctrl.oldAppDetails.push(detail);
				})
			}
		})
		$ctrl.totalSelect = $ctrl.appDetails.length + $ctrl.oldAppDetails.length;
		$ctrl.filter();
    };

	$ctrl.pageChanged = function () {
		$ctrl.filter();
	};

	 $ctrl.filter = function () {
		$http.get('/details/filter', {
			params: {
				page: $ctrl.page,
				perPage: $ctrl.perPage,
				categoryId: $ctrl.category ? $ctrl.category.id : null,
				search: $ctrl.search,
			}
		}).then(function (response) {
			$ctrl.details = response.data.data;
			$ctrl.total = response.data.total;
			$ctrl.details.forEach(function (detail) {
				if ($ctrl.oldAppDetails.length) {
					let ind = $ctrl.oldAppDetails.findIndex(v => v.detail_id === detail.id);
					if (ind !== -1) {
						detail.checked = $ctrl.oldAppDetails[ind].checked;
						detail.amount = $ctrl.oldAppDetails[ind].amount;
						detail.cost = $ctrl.oldAppDetails[ind].cost;
					}
				}
				if ($ctrl.appDetails.length) {
					let ind = $ctrl.appDetails.findIndex(v => v.detail_id === detail.id);
					if (ind !== -1) {
						detail.checked = $ctrl.appDetails[ind].checked;
						detail.amount = $ctrl.appDetails[ind].amount;
						detail.cost = $ctrl.appDetails[ind].cost;
					}
				}
			})
		},function (error) {
			alert("Что-то пошло не так");
		});
	}

	$ctrl.reset =  function () {
		$ctrl.page = 1;
		$ctrl.search = null;
		$ctrl.category = null;
	 	$ctrl.filter();
	}

	$ctrl.checkDetail = function (detail) {
	 	if (detail.checked) {
	 		let newDetail = {
				checked: true,
	 			detail_id: detail.id,
	 			name: detail.name,
				category_id: detail.category_id,
				unit: detail.unit,
			}
	 		$ctrl.appDetails.push(newDetail);
		} else {
			let index = $ctrl.appDetails.findIndex(v => v.detail_id === detail.id);
			$ctrl.appDetails.splice(index, 1);
		}
		$ctrl.totalSelect = $ctrl.appDetails.length + $ctrl.oldAppDetails.length;
	}

	$ctrl.submit = function () {
	 	$ctrl.close({
			$value: {
				appDetails: $ctrl.appDetails,
			},
		});
	}
}